import React from 'react'

export default class OptionButtonPR extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			active: false
		}
	}

	onButtonClick = e => {
		const {handler,setPVAnswer} = this.props
		let answer = e.currentTarget.getAttribute('name')
		setPVAnswer([answer])
		this.setState({
			active: true
		})
		document.getElementsByClassName('pv')[0].classList.add('pv--no-click')

		setTimeout(function(){ 
			handler()
		}, 500)
	}

	render(){
		const {
			icon,
			name,
			path
		} = this.props

		const {
			active
		} = this.state

		let iconfile
		let assetPath
		if(icon){
			iconfile = icon.field.icon_schwarz.filename
			if(active){
				iconfile = icon.field.icon_blau.filename
			}
			assetPath = path.concat(iconfile)
		}
		if(!icon){
			return null
		}
		return(
			<img name={name} className='icon' src={assetPath} onClick={this.onButtonClick}/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/presentationReferral/subcomponents/optionButtonPR.js